


















import VueOptions from '@utils/VueOptions'
import TitlePatternUtility from '@utils/TitlePatternUtility'

settings =
  name: 'FormFieldTitlePattern'

  vue:
    props: ['value', 'errors', 'placeholder']

    data: ->
      pattern: @value || ''

    computed:
      tokens: ->
        TitlePatternUtility.getAllTokens()

    methods:
      hiInputChange: (pattern) ->
        @inputChange pattern

      hiAddToken: (token) ->
        tokenStr = " {{#{token}}} "
        inputEl = @$refs.inputPattern.$el.firstElementChild
        targetIndex = inputEl.selectionStart || @pattern.length
        pattern = @pattern.substr(0, targetIndex).trim() + tokenStr + @pattern.substr(targetIndex).trim()
        pattern = pattern.trim()
        @pattern = pattern
        @inputChange pattern
        setTimeout(() =>
          newIndex = targetIndex + tokenStr.length - 1
          inputEl.focus()
          inputEl.setSelectionRange newIndex, newIndex
        , 0)

      inputChange: (pattern) ->
        @$emit 'input', pattern
        @$emit 'change', pattern

export default VueOptions.vue settings
